import fetch from 'isomorphic-fetch';
import * as serviceCallConfig from './../config/api_urls';
import { response_Manager } from './api_manager';
import formurlencoded from 'form-urlencoded';

export var makeServiceCall = (reqType, dispatch, endPoint,
    payLoad, requestFrom, isURLEncoded, authKey = '', api_key = '', getParams, multipart, uniqueKey) => {


    api_key = api_key.trim() || serviceCallConfig.API_KEY.trim();
    if (!navigator.onLine) {
        return response_Manager(true, dispatch, requestFrom,
            payLoad, {
            message: 'User is offline.'
        }, null, endPoint, endPoint);
    }

    let parsedPayload;
    if (!isURLEncoded) {
        parsedPayload = JSON.stringify(payLoad);
    } else if (multipart) {
        parsedPayload = payLoad;
    }
    else {
        parsedPayload = formurlencoded(payLoad);
    }
    authKey = authKey ? (authKey).trim() : "";

    // var custom_headers;
    // if (authKey && !multipart) {
    //     custom_headers = new Headers({
    //         'Content-Type': isURLEncoded ? 'application/x-www-form-urlencoded' : 'application/json',
    //         // api_key: api_key,
    //         // auth_key: authKey
    //         'authorization': 'Bearer ' + authKey// authKey,
    //     });
    // }
    // else if (multipart) {
    //     custom_headers = new Headers({
    //         'authorization': 'Bearer ' + authKey// authKey,
    //     });
    // }
    // else {
    //     custom_headers = new Headers({
    //         'Content-Type': isURLEncoded ? 'application/x-www-form-urlencoded' : 'application/json',
    //     });
    // }

    var custom_headers;
    var headerObj = {};

    if (!multipart) {
        headerObj = {
            //'Content-Type': isURLEncoded ? 'application/x-www-form-urlencoded' : 'application/json'
            'Content-Type': isURLEncoded ? 'application/x-www-form-urlencoded' : 'application/json'
        }
    }

    if (authKey) {
        headerObj['authorization'] = 'Bearer ' + authKey;

    }
    headerObj['unique-key'] = uniqueKey;
    custom_headers = new Headers(headerObj);

    let reqObj = {
        headers: custom_headers
    };
    if (reqType === serviceCallConfig.API_POST) {
        reqObj = {
            headers: custom_headers,
            method: serviceCallConfig.API_POST,
            body: parsedPayload
        };
    }
    if (reqType === serviceCallConfig.API_PUT) {
        reqObj = {
            headers: custom_headers,
            method: serviceCallConfig.API_PUT,
            body: parsedPayload
        };
    }

    if (reqType === serviceCallConfig.API_DELETE) {
        reqObj = {
            headers: custom_headers,
            method: serviceCallConfig.API_DELETE,
            body: parsedPayload
        };
    }

    if (getParams && reqType == serviceCallConfig.API_PUT) {
        endPoint = endPoint + getParams;
    } 

    if (getParams && reqType == serviceCallConfig.API_GET) {
        endPoint = endPoint + getParams;
    }

    return fetch(endPoint, reqObj)
        .then(response => {

            return response.json();
        }).then(json => {
            return response_Manager(false, dispatch, requestFrom,
                payLoad, json, null, endPoint);
        })
        .catch(err => {
            return response_Manager(true, dispatch, requestFrom,
                payLoad, null, err, endPoint);
        });
};



/** WEBPACK FOOTER **
 ** ./src/base/api_service.js
 **/